function isValidFullUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (error) {
    return false;
  }
}

export { isValidFullUrl };
